var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.032 15.008L14.016 6.176H15.008V15.04C15.008 15.3067 14.912 15.5307 14.72 15.712C14.528 15.904 14.2987 16 14.032 16H0V1.968C0 1.70133 0.0906667 1.472 0.272 1.28C0.464 1.088 0.693333 0.992 0.96 0.992H9.824V1.984H0.96L0.992 15.008H14.032ZM6.32 8.976L7.312 7.968L8.032 8.688L7.024 9.68L6.32 8.976ZM15.296 0L16 0.704L8.752 7.952L8.048 7.248L12.496 2.8L12.992 2.288L14 1.296L15.296 0Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/Rename.73347ca63172fa7f6cce8438195d32ec.svg";
export { ForwardRef as ReactComponent };